<template src="./Details.html"></template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("leaves/getDetails", this.itemId)
            .then(() => {

            })
            .catch(() => { });
    },
    computed: {
        leave() {
            return this.$store.state.leaves.leave;
        }
    },
    methods: {

        download() {
            window.open(
                `/api/leaves/${this.leave.attachmentId}/attachment`,
                "_blank"
            );
        }
    },
};
</script>